export default {
	propertymanagers: {
		footerText: {
			beforeLink: 'Die',
			linkText: 'Aareon Deutschland GmbH',
			afterLink:
				'ist der Betreiber dieses Portals und handelt im Auftrag Ihrer {propertyManagersLabel}: Als Ihre Hausverwaltung sind wir der Verantwortliche für diese Datenverarbeitung. Wir bedienen uns hierfür des Plattformanbieters Aareon Deutschland GmbH als unseren Unterauftragnehmer.',
		},
		label: 'Hausverwaltung | Hausverwaltungen',
		visibility: {
			title: 'Verwalter-Sichtbarkeit',
			description:
				'Steuern Sie, welche Hausverwaltungen für Mieter und Eigentümer in der App sichtbar sind. Mindestens eine Hausverwaltung muss sichtbar bleiben.',
			column: {
				name: 'Name',
				address: 'Adresse',
				visible: 'In App sichtbar',
			},
			tooltip: {
				lastVisible:
					'Mindestens ein Verwalter muss in der App sichtbar bleiben.',
			},
			emptyState: 'Keine Hausverwaltungen gefunden.',
			savingProgress: '{done} von {total} gespeichert',
			savingInProgress:
				'Die Sichtbarkeit wird gerade gespeichert. Bitte warten Sie, bis alle Verwalter uebernommen sind.',
			loadError: 'Hausverwaltungen konnten nicht geladen werden.',
		},
	},
}
